import React from 'react';
import { MultiSelect } from "react-multi-select-component";

function MultiSelectInput({ input, meta, label, options, empty, ...rest }){
    return (
    <div className={"form-control w-full max-w-xs overflow-visible" + rest.className ? rest.className : ""}>
      {label && (
        <label htmlFor={input.name} className={"label " + (rest.labelClassName ? rest.labelClassName : "")}>
          <span className="label-text">{label}</span>
        </label>
      )}
      <MultiSelect
        options={options}
        onChange={(v) => {
          if(rest.single){
            if(v.length !== 0){
              const last_value = [v[v.length-1]]
              input.onChange(last_value)
            } else {
              input.onChange(v)
            }
          } else {
              input.onChange(v)
          }
        }} //if v is array to prevent crash??
        labelledBy="Select"
        value={(input.value==="" || !input.value) ? [] : input.value}
        className={" " + (rest.inputClassName ? rest.inputClassName : "")}
        hasSelectAll={!rest.disableSelectAll}
      />
    </div>
  );
};

export default MultiSelectInput;